<template>
  <div class="Examine">
    <div>
      <el-select v-if="$store.state.Login.Jurisdiction == 0" size="medium" v-model="Factory" style="width: 110px; padding: 0px 0px 0px 10px;" clearable :placeholder="$t('system.选择厂区')">
        <el-option
          v-for="item in $PublicJs.factory"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-input size="medium" clearable v-model="text" onkeyup="value=value.replace(/[^a-zA-Z0-9]/g,'').toUpperCase()" @blur="text=text.replace(/[^a-zA-Z0-9]/g,'').toUpperCase()" oninput="if (value.trim() === '') { value = null; }" @keyup.enter="Butsele()" style="width: 200px; padding: 0px 10px 0px 10px;" :placeholder="$t('All.料号')"></el-input>
      <el-button type="primary" icon="el-icon-search" size="small" @click="Butsele()">{{$t('All.搜索')}}</el-button>
      <el-button  size="small" @click="dataadd()" type="warning">{{this.$t('system.新增')}}</el-button>
    </div>
    <div style="height: calc(100% - 75px);">
      <template>
        <el-table :data="tableData" style="width: 100%" height="100%">
          <el-table-column align="center" :label="this.$t('system.序号')" type="index" width="90">
          </el-table-column>
          <el-table-column align="center" prop="Date" :label="this.$t('system.创建日期')" width="180">
          </el-table-column>
          <el-table-column align="center" prop="Update_time" :label="this.$t('All.最后一次更新时间')" width="180">
          </el-table-column>
          <el-table-column align="center" prop="Item_no" :label="this.$t('system.料号')">
          </el-table-column>
          <el-table-column align="center" prop="Product_name" :label="this.$t('system.品名规格')">
          </el-table-column>
          <el-table-column align="center" prop="Customer"  :label="this.$t('system.客户')">
          </el-table-column>
          <el-table-column align="center" prop="Entered" :label="this.$t('system.lururen')" >
          </el-table-column>
          <el-table-column align="center" :label="this.$t('system.操作')" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" @click="UserDataSelect(scope.row)" type="primary">Review</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <el-pagination
      style="text-align: center; padding: 5px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageindex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      tableData: [],
      total: 0,
      page_size: 10,
      pageindex: 1,
      text: '',
      Factory: ''
    }
  },
  props: ['Addtab', 'RemoveTab', 'Renewtargename', 'Rendw'],
  created () {
    this.IPQCAdminData()
  },
  mounted () {

  },
  methods: {
    ...mapMutations(['UserData']),
    async IPQCAdminData () {
      const fqcdata = {
        Text: this.text,
        Factory: this.Factory,
        Pageindex: this.pageindex,
        PageSize: this.page_size,
        UserData: this.$store.state.Login
      }
      const { data: res } = await this.$http.post('/api/IPQC/IPQCAdminData', fqcdata)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.total = res.response.TotalCount
      this.tableData = res.response.Ipqc
    },
    async Butsele () {
      this.pageindex = 1
      this.page_size = 10
      this.IPQCAdminData()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.IPQCAdminData()
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.IPQCAdminData()
    },
    async UserDataSelect (row) {
      this.$message.success(this.$t('All.即将进入编辑页面'))
      this.UserData(row)
      this.Addtab(this.$t('All.IPQC模版') + '-' + row.Number, 'IPQCAdmin')
    },
    dataadd () {
      this.Addtab(this.$t('All.新增IPQC模版'), 'IPQCSeleItemAdmin')
    }
  }
}
</script>
<style lang="less" scoped>
.Examine {
  height: 100%;
}
</style>
